import { render } from "./LogoCarousel.vue?vue&type=template&id=713cdb0e"
import script from "./LogoCarousel.vue?vue&type=script&lang=js"
export * from "./LogoCarousel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/scripts/sections/common/LogoCarousel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "713cdb0e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('713cdb0e', __exports__)) {
    api.reload('713cdb0e', __exports__)
  }
  
  module.hot.accept("./LogoCarousel.vue?vue&type=template&id=713cdb0e", () => {
    api.rerender('713cdb0e', render)
  })

}


export default __exports__